import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 21v5h24v-5h2v7H2v-7h2ZM17 4v13.22l6.341-5.549 1.318 1.505L16 20.753l-8.659-7.577 1.318-1.505L15 17.22V4h2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcDownload;
